module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9953/js/img/OperationsHub_Icon.svg"